import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    container: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginTop: '20px',
        flexFlow: 'row wrap',
    },

    containerAdjuntos: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginTop: '7px',
        flexFlow: 'row wrap',
    },

    nroInternacion: {
        width: '175px',
        margin: '0px 7px',
    },

    nombreSocio: {
        width: '175px',
        margin: '0px 7px',
    },

    btnAdjuntar: {
        height: '38px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px 18px',
        borderRadius: '6px',
        fontWeight: '500',
        fontSize: '13px',
        lineHeight: '18px',
        color: '#02599E',
        minWidth: '190px',
        cursor: 'pointer',
        marginRight: '15px',
        textTransform: 'none',
        border: '1px dashed rgba(182, 182, 182, 0.41)',
        marginLeft: '7px',
        '&:focus': {
            outline: 'none',
        },
        '&:hover': {
            border: '1px dashed rgba(164, 163, 163, 0.84)',
            background: '#FFFFFF',
        },
    },

    iconoUpload: {
        width: '20px',
        marginRight: '8px',
    },

    containerAlineado: {
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        '&:focus': {
            outline: 'none',
        },
    },

    containerNroInvalido: {
        height: '38px',
        width: '175px',
        margin: '0px 7px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    nroInvalido: {
        fontWeight: "400",
        fontSize: "90%",
        color: "#D01919",
        marginTop: "5px",
    },

});
